'use es6';

import { Component } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import { Modal } from 'foundations-components/transitional/components/Modal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import { H4 } from 'foundations-components/transitional/components/H4';
import FormattedMessage from 'I18n/components/FormattedHTMLMessage';
import { REPORT_TYPES as SALES_PERFORMANCE_TYPES } from 'reporting-data/constants/salesPerformanceConstants';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { Map as ImmutableMap, List } from 'immutable';
import get from 'transmute/get';
import PropTypes from 'prop-types';
import { ReportType } from '../../reportPropTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ORDERED_STAGES = List(Object.keys(SALES_PERFORMANCE_TYPES));
const setStagesOnReport = (report, stages) => {
  return report.setIn(['displayParams', 'customWidget', 'options', 'values'], ORDERED_STAGES.filter(stage => stages.has(stage)).map(property => ImmutableMap({
    property
  })));
};
const getStagesOnReport = report => {
  return report.getIn(['displayParams', 'customWidget', 'options', 'values'], List()).map(get('property')).toSet();
};
export default class SalesPerformanceCustomizeModal extends Component {
  constructor(props) {
    super(props);
    this.handleSave = () => {
      const {
        onConfirm,
        report
      } = this.props;
      const {
        selectedStages
      } = this.state;
      onConfirm(setStagesOnReport(report, selectedStages));
    };
    this.renderPipelineOption = stage => {
      const {
        selectedStages
      } = this.state;
      const onChange = ({
        target: {
          checked
        }
      }) => {
        this.setState({
          selectedStages: checked ? selectedStages.add(stage) : selectedStages.remove(stage)
        });
      };
      return /*#__PURE__*/_jsx(UICheckbox, {
        checked: selectedStages.has(stage),
        onChange: onChange,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `reporting-ui-components.reportActions.customize.data.types.${stage}`
        })
      }, stage);
    };
    const {
      report: _report
    } = props;
    this.state = {
      selectedStages: getStagesOnReport(_report)
    };
  }
  render() {
    const {
      onReject
    } = this.props;
    return /*#__PURE__*/_jsxs(Modal, {
      width: 540,
      onEsc: onReject,
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onReject
        }), /*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-ui-components.reportActions.customize.header"
          })
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: ORDERED_STAGES.map(this.renderPipelineOption)
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          onClick: this.handleSave,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-ui-components.reportActions.customize.save"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onReject,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-ui-components.reportActions.customize.cancel"
          })
        })]
      })]
    });
  }
}
SalesPerformanceCustomizeModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  report: ReportType.isRequired,
  options: PropTypes.object.isRequired
};